// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2xdI9","range":"MonthRangeSwitch_range__2wkhg","disabled":"MonthRangeSwitch_disabled__1K3d4"};